/**
 * OVERRIDE SummaryTemplate.jsx
 */

import SummaryTemplate from '../../../../../components/Blocks/Listing/SummaryTemplate';

export default SummaryTemplate;